<div class="page-container" [class.loading]="isLoading">
    <app-header
        [title]="'benefits.benefitsPayroll.addABenefit'"
        [back]="true"
        [backRoute]="benefitSettingsRoute"
    ></app-header>
    <div class="form-container">
        <ui-card class="grow" [withMargin]="false">
            <form #benefitCategoryForm="ngForm" class="app-grid">
                <div class="columns-6 app-grid">
                    <mat-form-field>
                        <mat-label appRemoveAriaOwns>{{
                            'benefits.benefitsPayroll.benefitCategory' | translate
                        }}</mat-label>
                        <mat-select
                            required
                            name="benefitTypeId"
                            #benefitTypeId="ngModel"
                            [(ngModel)]="benefit.benefitTypeId"
                            (ngModelChange)="onBenefitTypeChanged($event)"
                            placeholder="{{ 'payroll.benefits.typePlaceholder' | translate }}"
                        >
                            <mat-option
                                *ngFor="let benefitCategory of benefitCategories"
                                [value]="benefitCategory.payrollBenefitTypeId"
                                >{{ benefitCategory.hrBenefitName }}</mat-option
                            >
                        </mat-select>
                        <mat-error *ngIf="benefitTypeId.invalid">{{ benefitTypeId.errors | formErrors }}</mat-error>
                    </mat-form-field>
                </div>
            </form>

            <app-company-benefit-form
                #form
                [benefit]="benefit"
                [benefitTypes]="route.snapshot.data.benefitTypes"
                [hrBenefitMode]="true"
            ></app-company-benefit-form>
        </ui-card>

        <ui-card [withMargin]="false">
            <app-benefit-taxation [benefitType]="benefitType"></app-benefit-taxation>
        </ui-card>
    </div>

    <div class="flex row justify-end">
        <ui-button [routerLink]="benefitSettingsRoute">{{ 'payroll.benefits.cancel' | translate }} </ui-button>
        <ui-button type="primary" (click)="save(form, benefitCategoryForm)"
            >{{ 'payroll.benefits.save' | translate }}
        </ui-button>
    </div>
</div>
